var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-leak-list animated fadeIn roundedCard" },
    [
      _c("b-card", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("b-card", { staticClass: "dashboard-container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-xl-3" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-xl-2 dashboard-filter" },
                        [
                          _c("label", { staticClass: "font-weight-bold" }, [
                            _vm._v("Tenant"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-xl-10" },
                        [
                          _c(
                            "b-form-select",
                            {
                              staticClass: "dashboard-filter-input",
                              model: {
                                value: _vm.tenantSelection,
                                callback: function ($$v) {
                                  _vm.tenantSelection = $$v
                                },
                                expression: "tenantSelection",
                              },
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(
                                  "\n                      All Tenants\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.tenants, function (tenant) {
                                return _c(
                                  "option",
                                  _vm._b(
                                    {
                                      key: tenant.id,
                                      domProps: { value: { id: tenant.id } },
                                      on: {
                                        option: function ($event) {
                                          return _vm.$emit(
                                            "option",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    },
                                    "option",
                                    _vm.$attrs,
                                    false
                                  ),
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(tenant.name) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-xl-7" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-xl-2 text-right dashboard-filter",
                        },
                        [
                          _c("label", { staticClass: "font-weight-bold" }, [
                            _vm._v("Time Period"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-xl-4" },
                        [
                          _c("b-form-input", {
                            staticClass: "dashboard-filter-input date-picker",
                            attrs: {
                              id: "dateFrom",
                              type: "date",
                              name: "dateFrom",
                              placeholder: "YYYY-MM-DD",
                            },
                            model: {
                              value: _vm.dateFrom,
                              callback: function ($$v) {
                                _vm.dateFrom = $$v
                              },
                              expression: "dateFrom",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-xl-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dateTo,
                              expression: "dateTo",
                            },
                          ],
                          staticClass:
                            "dashboard-filter-input form-control date-picker",
                          attrs: {
                            id: "dateTo",
                            type: "date",
                            name: "dateTo",
                            placeholder: "YYYY-MM-DD",
                          },
                          domProps: { value: _vm.dateTo },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.dateTo = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-xl-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary applyFilter pull-right",
                        attrs: {
                          id: "applyBtn",
                          type: "submit",
                          disabled: _vm.applyBtnDisabled,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.applyButtonClicked.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n                Apply\n              ")]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "animated fadeIn roundedCard" },
          [
            _c("b-card", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-xl-3" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { height: "8rem" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body align-items-center" },
                            [
                              _c(
                                "h4",
                                { staticClass: "card-title-dashboard" },
                                [
                                  _vm._v(
                                    "\n                      Total Shipped Devices\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isLoadingOrdersAndRegistrationsList
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-text-dashboard-numbers text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.ordersAndRegistrationsList[0]
                                              ? _vm
                                                  .ordersAndRegistrationsList[0]
                                                  .total_delivered
                                              : 0
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isLoadingOrdersAndRegistrationsList
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text-spinner text-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { height: "8rem" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body align-items-center" },
                            [
                              _c(
                                "h4",
                                { staticClass: "card-title-dashboard" },
                                [
                                  _vm._v(
                                    "\n                      Total Registered Devices\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isLoadingOrdersAndRegistrationsList
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-text-dashboard-numbers text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.ordersAndRegistrationsList[0]
                                              ? _vm
                                                  .ordersAndRegistrationsList[0]
                                                  .total_registered
                                              : 0
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isLoadingOrdersAndRegistrationsList
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text-spinner text-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-xl-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { height: "7.75rem" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body align-items-center" },
                            [
                              _c(
                                "h5",
                                { staticClass: "card-title-dashboard" },
                                [
                                  _vm._v(
                                    "\n                      Post-Repair NPS\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isLoadingMarketingMetricsList
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-text-dashboard-numbers text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.marketingMetricsList[0]
                                              ? _vm.marketingMetricsList[0]
                                                  .average_nps_score_percentage
                                                ? _vm.marketingMetricsList[0]
                                                    .average_nps_score_percentage
                                                : "N/A"
                                              : "N/A"
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isLoadingMarketingMetricsList
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text-spinner text-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-xl-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { height: "7.75rem" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body align-items-center" },
                            [
                              _c(
                                "h5",
                                { staticClass: "card-title-dashboard" },
                                [
                                  _vm._v(
                                    "\n                      Post-Repair CSAT\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isLoadingMarketingMetricsList
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-text-dashboard-numbers text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.marketingMetricsList[0]
                                              ? _vm.marketingMetricsList[0]
                                                  .average_csat_percentage
                                                ? _vm.marketingMetricsList[0]
                                                    .average_csat_percentage
                                                : "N/A"
                                              : "N/A"
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isLoadingMarketingMetricsList
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text-spinner text-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-xl-7" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body dashboard-chart" }, [
                      !_vm.isLoadingMonthlyRegistrationsList
                        ? _c(
                            "div",
                            { staticClass: "chart-wrapper" },
                            [
                              _c("BarComboChart", {
                                attrs: {
                                  "cumulative-registered-devices":
                                    _vm.cumulativeRegisteredDevices,
                                  "registered-devices":
                                    _vm.totalRegisteredDevices,
                                  categories: _vm.registeredDeviceCategories,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isLoadingMonthlyRegistrationsList
                        ? _c(
                            "div",
                            { staticClass: "card-text-spinner text-center" },
                            [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-xl-2" }, [
                  _c("div", { staticClass: "card-ROI" }, [
                    _c("div", { staticClass: "card-body align-items-center" }, [
                      _c("h5", { staticClass: "card-title-ROI text-center" }, [
                        _vm._v(
                          "\n                  ROI Dashboard\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.lastUpdatedDate
                        ? _c(
                            "p",
                            {
                              staticClass: "card-text-ROI-updated text-center",
                            },
                            [
                              _vm._v(
                                "\n                  Last updated: " +
                                  _vm._s(_vm.lastUpdatedDate) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", { staticClass: "card-text-ROI" }, [
                        _vm._v(
                          "\n                  Average cost to claim\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isLoadingDamageCausingRepairs &&
                      _vm.isLoadingWorkOrderClaimSavings
                        ? _c(
                            "div",
                            {
                              staticClass: "card-text-roi-spinner text-center",
                            },
                            [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoadingDamageCausingRepairs &&
                      !_vm.isLoadingWorkOrderClaimSavings
                        ? _c(
                            "p",
                            { staticClass: "card-text-ROI-value text-center" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.averageCostToClaim(),
                                      _vm.currencyCode
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", { staticClass: "card-text-ROI" }, [
                        _vm._v(
                          "\n                  Number of claims saved\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isLoadingDamageCausingRepairs
                        ? _c(
                            "div",
                            {
                              staticClass: "card-text-roi-spinner text-center",
                            },
                            [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoadingDamageCausingRepairs
                        ? _c(
                            "p",
                            { staticClass: "card-text-ROI-value text-center" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.damageCausingRepairsFixed) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", { staticClass: "card-text-ROI" }, [
                        _vm._v(
                          "\n                  Estimated Claims Savings\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isLoadingWorkOrderClaimSavings
                        ? _c(
                            "div",
                            {
                              staticClass: "card-text-roi-spinner text-center",
                            },
                            [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoadingWorkOrderClaimSavings
                        ? _c(
                            "p",
                            { staticClass: "card-text-ROI-value text-center" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.estimatedClaimsSavings(),
                                      _vm.currencyCode
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", { staticClass: "card-text-ROI" }, [
                        _vm._v(
                          "\n                  Cost of Programme\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isLoadingCostOfProgramme
                        ? _c(
                            "div",
                            {
                              staticClass: "card-text-roi-spinner text-center",
                            },
                            [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoadingCostOfProgramme
                        ? _c(
                            "p",
                            { staticClass: "card-text-ROI-value text-center" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.programme(),
                                      _vm.currencyCode
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", { staticClass: "card-text-ROI" }, [
                        _vm._v(
                          "\n                  Return on Investment\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isLoadingCostOfProgramme &&
                      _vm.isLoadingWorkOrderClaimSavings
                        ? _c(
                            "div",
                            {
                              staticClass: "card-text-roi-spinner text-center",
                            },
                            [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoadingCostOfProgramme &&
                      !_vm.isLoadingWorkOrderClaimSavings
                        ? _c(
                            "p",
                            { staticClass: "card-text-ROI-value text-center" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.roi()) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [_vm._v(" \n          ")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-xl-3" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body dashboard-feedback" }, [
                      _c("h4", { staticClass: "card-title-dashboard" }, [
                        _vm._v(
                          "\n                  Customer Feedback\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isLoadingCustomerFeedbackList
                        ? _c(
                            "div",
                            _vm._l(_vm.customerFeedbackList, function (item) {
                              return _c("div", { key: item.leakbot_id }, [
                                _c(
                                  "p",
                                  { staticClass: "card-text-dashboard" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm._f("moment")(item.created_on)
                                        ) +
                                        " - " +
                                        _vm._s(item.leakbot_id) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(item.customer_feedback) +
                                      "\n                    "
                                  ),
                                ]),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isLoadingCustomerFeedbackList
                        ? _c(
                            "div",
                            { staticClass: "card-text-spinner text-center" },
                            [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-xl-7" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-xl-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { height: "8rem" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body align-items-center" },
                            [
                              _c(
                                "h5",
                                { staticClass: "card-title-dashboard" },
                                [
                                  _vm._v(
                                    "\n                      Leak Alerts\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isLoadingLowLeakAlerts
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-text-dashboard-numbers text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.lowLeakAlerts
                                              .total_lowleak_alerts
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isLoadingLowLeakAlerts
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text-spinner text-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-xl-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { height: "8rem" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body align-items-center" },
                            [
                              _c(
                                "h5",
                                { staticClass: "card-title-dashboard" },
                                [
                                  _vm._v(
                                    "\n                      Repair Visits\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isLoadingRepairs
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-text-dashboard-numbers text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(_vm.repairs.total_repairs) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isLoadingRepairs
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text-spinner text-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-xl-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { height: "8rem" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body align-items-center" },
                            [
                              _c(
                                "h5",
                                { staticClass: "card-title-dashboard" },
                                [
                                  _vm._v(
                                    "\n                      Number of Claims Saved\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.isLoadingDamageCausingRepairs
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "card-text-dashboard-numbers text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(_vm.damageCausingRepairs) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "badge text-bg-secondary" },
                                  [
                                    _vm._v(
                                      "Of Repair Visits: " +
                                        _vm._s(
                                          _vm.percentageClaimsInRepairVisits()
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.isLoadingDamageCausingRepairs
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text-spinner text-center",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-body dashboard-chart" },
                          [
                            !_vm.isLoadingLeakCategoriesList
                              ? _c(
                                  "div",
                                  { staticClass: "chart-wrapper" },
                                  [
                                    _c("PieChart", {
                                      attrs: {
                                        "leaks-fixed": _vm.totalRepairs,
                                        "leaks-labels": _vm.leakCategories,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isLoadingLeakCategoriesList
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "card-text-spinner text-center",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }